module.exports = __webpack_public_path__ + "theme/assets/img/36820ca130371f23461e8708dd887f33.png";